import CustomButton from "@/components/custom-button/custom-button";
import { styled } from "styled-components";

export const BorderlessButton = styled(CustomButton)`
  &.ant-btn {
    border: none;
    box-shadow: none;
    
    &:hover, &:focus {
      border: none;
      box-shadow: none;
    }
  }
`;

export const ContentStyled = styled.div`
  display: flex;
  width: 100%;
  max-width: 404px;
  padding: 32px;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
`;

export const TitleStyled = styled.div`
  color: ${({ theme }) => theme.colors.text.headings};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "Red Hat Display", arial;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 24px */;
`;

export const DescriptionStyled = styled.div`
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  color: ${({ theme }) => theme.colors.text.paragraphs};
  text-overflow: ellipsis;
  font-family: "Red Hat Display", arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  span.paragraph {
    color: ${({ theme }) => theme.colors.text.paragraphs};
    font-weight: 700;
  }
`;
